// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"LoadingIndicator_loadingIndicator__8KnwZ","l5":"LoadingIndicator_l5__1fqzp"};